interface Props {
  size?: number;
  color?: string;
}

const SuccessModalIcon = (props: Props) => {
  const { color = '#3BD378', size = 112 } = props;

  return (
    <svg
      width={112}
      height={112}
      viewBox={`0 0 112 112`}
      style={{ width: size, height: size }}
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M39.4757 58.0526L48.7641 67.341L71.9852 44.12"
        stroke="black"
        strokeWidth="6.96631"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.5095 15.5016C39.3405 11.55 47.2716 9.28845 55.7305 9.28845C81.3795 9.28845 102.173 30.0813 102.173 55.7305C102.173 81.3795 81.3795 102.173 55.7305 102.173C30.0813 102.173 9.28845 81.3795 9.28845 55.7305C9.28845 47.2716 11.55 39.3405 15.5016 32.5095"
        stroke={color}
        strokeWidth="6.96631"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default SuccessModalIcon;
